import * as React from "react"

const AppStore = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="currentcolor"
    {...props}
  >
    <path
      d="M9.15049,20c1.19655,0,1.727-.82645,3.21958-.82645,1.51726,0,1.85032.801,3.18256.801,1.30757,0,2.18339-1.246,3.00987-2.46662a11.37164,11.37164,0,0,0,1.33224-2.83535,4.37827,4.37827,0,0,1-2.59046-4.04323A4.55071,4.55071,0,0,1,19.389,6.815a4.51043,4.51043,0,0,0-3.83635-1.98348c-1.46793,0-2.66447.91545-3.41694.91545-.81414,0-1.88734-.86459-3.15789-.86459-2.41777,0-4.87254,2.05976-4.87254,5.95041a12.56253,12.56253,0,0,0,2.03536,6.62429C7.1028,18.85569,7.94161,20,9.15049,20ZM12.23438,4.61538a3.77151,3.77151,0,0,0,2.62746-1.424A4.62638,4.62638,0,0,0,15.88569.39415,1.94061,1.94061,0,0,0,15.84868,0a4.2733,4.2733,0,0,0-2.8495,1.52575A4.38519,4.38519,0,0,0,11.93832,4.234a1.79621,1.79621,0,0,0,.037.356A1.37621,1.37621,0,0,0,12.23438,4.61538Z"
      fillRule="evenodd"
    />
  </svg>
)

export default AppStore
